import React, { Component, Fragment } from "react";
import WriterHeader from "../writer/account/Header";
import AdminHeader from "../admin/Header";
import EmployerHeader from "../employer/account/Header";
import AppContext from "../../contexts/AppContext";

import TimeAgo from "react-timeago";
import ReactQuill, { Quill } from "react-quill";
import quillEmoji from "quill-emoji";
import { getRooms, getMessages, send, records } from "../../services/message";
import * as download from "downloadjs";

import { Scrollbars } from "react-custom-scrollbars";
import { DropzoneComponent } from "react-dropzone-component";

import "react-quill/dist/quill.snow.css";
import "../../styles/tailwind-ui.min.css";

import enStrings from "react-timeago/lib/language-strings/en";
import buildFormatter from "react-timeago/lib/formatters/buildFormatter";
import { check } from "./../../services/userDatails";
import Waiting from "../utilities/Waiting";
import NoMessages from "../utilities/NoMessages";

const { EmojiBlot, ShortNameEmoji, ToolbarEmoji, TextAreaEmoji } = quillEmoji;
const formatter = buildFormatter(enStrings);

var Link = Quill.import('formats/link');
Link.sanitize = function(url) {
    // prefix default protocol.
    let protocol = url.slice(0, url.indexOf(':'));
    if (this.PROTOCOL_WHITELIST.indexOf(protocol) === -1) {
      url = 'http://' + url;
    }
    // Link._sanitize function
    let anchor = document.createElement('a');
    anchor.href = url;
    protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
    return (this.PROTOCOL_WHITELIST.indexOf(protocol) > -1) ? url : this.SANITIZED_URL;
  }
Quill.register(
    {

        "formats/emoji": EmojiBlot,
        "modules/emoji-shortname": ShortNameEmoji,
        "modules/emoji-toolbar": ToolbarEmoji,
        "modules/emoji-textarea": TextAreaEmoji,
    },
    true
);
Quill.register(Link, true);

export class Messages extends Component {
    state = {
        first_name: "",
        last_name: "",
        email: "",
        current_password: "",
        new_password: "",
        confirm_password: "",
        profile_URL: this.context.state.user.url,
        email_notification: true,
        public_profile: true,
        showDeleteModal: false,
        editorHtml: "",
        files: [],
        loading: true,
        room: {
            id: 0,
            user: {},
            job: {},
        },
        rooms: [],
        search: [],
        searching: false,
        messages: [],
        lastMessage: 0,
        togglePadding: 'message-content'
    };

    scrollToBottom = () => {
        const { scrollbar } = this.refs;
        if (scrollbar) {
            scrollbar.scrollToBottom(0);
        }
    };

    handleScroll = () => {
        const { scrollbar } = this.refs;
        var elements = document.querySelectorAll(".messageElement");
        for (let index = 0; index < elements.length; index++) {
            if (
                elements[index].offsetTop > scrollbar.getScrollTop() &&
                elements[index].offsetTop < scrollbar.getScrollTop() + 50
            ) {
                this.setState({ date: elements[index].getAttribute("date") });
            }
        }
    };

    componentDidMount() {
        if(this.context.state.user.email_verified === 'false') {
            this.setState({togglePadding: 'message-alert-content'});
          }
        //console.log(this.context.state.user.plan_id);
        getRooms()
            .then((response) => {
                if (this.props.match.params.key) {
                    response.data.map((room, i) => {
                        if (room.key === this.props.match.params.key) {
                            this.selectRoom(room);
                        }
                    });
                } else if (response.data.length >= 1) {
                    this.selectRoom(response.data[0]);
                }

                setInterval(() => {
                    if (this.state.room.id != 0) {
                        this.showMessages(this.state.room.id);
                    }
                }, 3000);

                this.setState({
                    loading: false,
                    search: response.data,
                    rooms: response.data,
                });
            })
            .catch((error) => {
                this.context.state.handelError(error);
            });

        var countDown = 0;
        setInterval(() => {
            if (countDown % 30 === 0) {
                if (this.state.searching === false) {
                    getRooms().then((response) => {
                        this.setState({ rooms: response.data });
                    });
                }
            }
            countDown = countDown + 1;
        }, 1000);
    }

    removeFile = (i) => {
        let temp = this.state.files;
        temp.splice(i, 1);
        this.setState({ files: temp });
    };

    renderHeader = () => {
        switch (this.context.state.user.type) {
            case "writer":
                return <WriterHeader></WriterHeader>;
                break;
            case "employer":
                return <EmployerHeader></EmployerHeader>;
                break;
            case "admin":
                return <AdminHeader></AdminHeader>;
                break;
        }
    };

    modules = {
        keyboard: {
            bindings: {
                enter: {
                    key: 13,
                    handler: () => {
                        this.sendMessage();
                        this.hideSymbols = !this.hideSymbols;
                    },
                },
            },
        },

        toolbar: {
            container: [
                ["bold", "italic", "underline", "strike" , "link"],
                ["emoji"],
            ],
            handlers: {
                link(value) {

                    if (value) {
                        const range = this.quill.getSelection();
                        if (range == null || range.length === 0) {
                            return;
                        }

                        let preview = this.quill.getText(range);

                        if (
                            /^\S+@\S+\.\S+$/.test(preview) &&
                            preview.indexOf("mailto:") !== 0
                        ) {
                            preview = `mailto:${preview}`;
                        }

                        preview = 'http:\\'+ preview ;

                        const { tooltip } = this.quill.theme;
                        tooltip.root.querySelector(
                            "input[data-link]"
                        ).dataset.link = "https://www.example.com";
                        tooltip.edit("link");
                    } else {
                        this.quill.format("link", false);
                    }
                },
            },
        },

        "emoji-toolbar": true,
        "emoji-textarea": true,
        "emoji-shortname": true,
    };

    formats = [
        "font",
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "code-block",
        "color",
        "background",
        "align",
        "link",
        "image",
        "clean",
        "emoji",
    ];

    djsConfig = {
        autoProcessQueue: true,
        params: {
            type: "temp",
            fileName: "",
        },

        parallelUploads: 1,
        timeout: 3600,
        headers: {
            Authorization: "Bearer " + localStorage.getItem("auth_token"),
        },
        maxFiles: 1,
        maxfilesexceeded: function (file) {
            this.removeAllFiles();
            this.addFile(file);
        },
        error: (file, error) => {
            this.context.state.showCodeMessage(error.message, "error");
        },
        queuecomplete: function () {
            this.removeAllFiles();
        },
        success: (file, response, data) => {
            if (file.status === "success") {
                let files = this.state.files;
                this.setState({ files: files.concat(response.data) });
                this.context.state.showCodeMessage(
                    "File uploaded successfully .",
                    "success"
                );
            } else {
                this.context.state.showCodeMessage(
                    "Error while uploading file .",
                    "error"
                );
            }
        },
    };

    handleChange = (html) => {
        this.setState({ editorHtml: html });
    };
    sendMessage = () => {
        if (this.state.editorHtm === "") return false;
        if(this.context.state.user.type =="writer" && this.context.state.user.plan_id == "1") return false;
            send(this.state.editorHtml, this.state.room.id, this.state.files)
                .then((response) => {
                    this.showMessages(this.state.room.id);
                })
                .catch((error) => {
                    this.context.state.handelError(error);
                });
        this.setState({ files: [], editorHtml: "" });
    };

    downloadFile = (url) =>{
        download(url);
    }
    showMessages = (roomId) => {
        if (this.state.checking === true) return false;
        this.setState({ checking: true });
        getMessages(roomId, this.state.lastMessage).then((response) => {
            let temp = this.state.messages;

            if (response.data[response.data.length - 1]) {
                this.setState({
                    lastMessage: response.data[response.data.length - 1].id,
                    messages: temp.concat(response.data),
                    checking: false,
                });
                this.scrollToBottom();
            } else {
                this.setState({
                    checking: false,
                });
            }
        });
    };

    roomSearch = (field) => {
        var temp = [];
        for (let i = 0; i < this.state.rooms.length; i++) {
            var query = field.target.value.toLowerCase();
            if (
                this.state.rooms[i].job.title.toLowerCase().indexOf(query) !=
                    -1 ||
                this.state.rooms[i].user.first_name
                    .toLowerCase()
                    .indexOf(query) != -1 ||
                this.state.rooms[i].user.last_name
                    .toLowerCase()
                    .indexOf(query) != -1
            ) {
                temp.push(this.state.rooms[i]);
            }
        }

        this.setState({
            search: temp,
            searching: this.state.rooms.length !== temp.length,
        });
    };
    selectRoom = (room) => {
        this.setState({ room: room, messages: [], lastMessage: 0 }, () => {
            this.showMessages(room.id);
            this.props.history.push(
                "/" + this.context.state.user.type + "/messages/" + room.key
            );
        });
    };

    render() {
        return (
            <Fragment>
                {this.renderHeader()}
                {this.state.loading === false ? (  
                    <Fragment>
                            <div className={`${this.state.togglePadding}`}>
                                <div className="m-auto">
                                    <div className=" bg-white   border-gray-200 border flex mb-4    messagePage">
                                        <div className="w-1/4 h-full  ">
                                            <ul>
                                                <li className="messageHeader roomSearch bg-gray-50 relative searchArea border-b border-gray-200 ">
                                                    <input
                                                        id="email"
                                                        onChange={
                                                            this.roomSearch
                                                        }
                                                        className="searchInput form-input   block w-full sm:text-sm sm:leading-5 "
                                                        placeholder="Search by name..."
                                                    />
                                                    <div className="absolute pin-r pin-t mt-3 mr-4 searchIcon">
                                                        <svg
                                                            version="1.1"
                                                            class="h-4 text-dark"
                                                            x="0px"
                                                            y="0px"
                                                            viewBox="0 0 52.966 52.966"
                                                        >
                                                            <path
                                                                d="M51.704,51.273L36.845,35.82c3.79-3.801,6.138-9.041,6.138-14.82c0-11.58-9.42-21-21-21s-21,9.42-21,21s9.42,21,21,21
                                                c5.083,0,9.748-1.817,13.384-4.832l14.895,15.491c0.196,0.205,0.458,0.307,0.721,0.307c0.25,0,0.499-0.093,0.693-0.279
                                                C52.074,52.304,52.086,51.671,51.704,51.273z M21.983,40c-10.477,0-19-8.523-19-19s8.523-19,19-19s19,8.523,19,19
                                                S32.459,40,21.983,40z"
                                                            />
                                                        </svg>
                                                    </div>
                                                </li>
                                                {this.state.search.map(
                                                    (room, i) => {
                                                        let className =
                                                            this.state.room
                                                                .key ===
                                                            room.key
                                                                ? "block activeMessage hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out"
                                                                : "block  hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out";
                                                        return (
                                                            <li key={room.id} className="border-b  border-gray-200" >
                                                                <a
                                                                    onClick={() =>
                                                                        this.selectRoom(
                                                                            room
                                                                        )
                                                                    }
                                                                    className={
                                                                        className
                                                                    }
                                                                >
                                                                    <div className="flex items-center px-4 py-4 sm:px-6">
                                                                        <div className="min-w-0 flex-1 flex items-center">
                                                                            <div className="flex overflow-hidden">
                                                                                {room.members.map(
                                                                                    (
                                                                                        member,
                                                                                        i
                                                                                    ) => {
                                                                                        if (
                                                                                            member.user_id !==
                                                                                            this
                                                                                                .context
                                                                                                .state
                                                                                                .user
                                                                                                .id
                                                                                        ) {
                                                                                            return (
                                                                                                <span className="inline-block relative">
                                                                                                    <img
                                                                                                        className="h-12 w-12 rounded-full"
                                                                                                        src={
                                                                                                            member
                                                                                                                .user
                                                                                                                .image
                                                                                                        }
                                                                                                        alt=""
                                                                                                    />
                                                                                                    {member
                                                                                                        .user
                                                                                                        .online ===
                                                                                                    "online" ? (
                                                                                                        <span className="absolute bottom-0 right-0 block h-2.5 w-2.5 rounded-full text-white shadow-solid bg-green-300"></span>
                                                                                                    ) : (
                                                                                                        <span className="absolute bottom-0 right-0 block h-2.5 w-2.5 rounded-full text-white shadow-solid bg-red-300"></span>
                                                                                                    )}
                                                                                                </span>
                                                                                            );
                                                                                        }
                                                                                    }
                                                                                )}
                                                                            </div>
                                                                            <div className="min-w-0 flex-1 px-4 md:grid md:grid-cols-1 md:gap-1">
                                                                                <div>
                                                                                    <div className="text-sm leading-5 font-medium text-base text-indigo-600 truncate">
                                                                                        {
                                                                                            room
                                                                                                .user
                                                                                                .first_name
                                                                                        }{" "}
                                                                                        {
                                                                                            room
                                                                                                .user
                                                                                                .last_name
                                                                                        }
                                                                                    </div>

                                                                                    <div className="mt-2 flex items-center text-sm leading-5 text-gray-500">
                                                                                        <span className="truncate">
                                                                                            {
                                                                                                room
                                                                                                    .job
                                                                                                    .title
                                                                                            }
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </li>
                                                        );
                                                    }
                                                )}
                                            </ul>
                                        </div>
                                        <div className="w-3/4 h-full border-l relative border-gray-200 ">
                                            <div className="messageHeader px-4 pt-3 py-2 border-b border-gray-200 bg-gray-50 sm:px-6">
                                                <h3 className="text-lg leading-6 font-medium text-gray-900 ">
                                                    {
                                                        this.state.room.user
                                                            .first_name
                                                    }{" "}
                                                    {
                                                        this.state.room.user
                                                            .last_name
                                                    }
                                                </h3>
                                                <p className="mt-1 max-w-2xl text-sm leading-5 text-gray-500">
                                                    {this.state.room.job.title}
                                                </p>
                                            </div>
                                            <div
                                                id="messageBody"
                                                className="messageBody  border-gray-200  border-b"
                                            >
                                                {this.state.date != null ? (
                                                    <div className="messageData border-gray-200  border-b ">
                                                        {this.state.date}
                                                    </div>
                                                ) : null}
                                                <Scrollbars
                                                    onScrollStop={
                                                        this.handleScroll
                                                    }
                                                    ref="scrollbar"
                                                >
                                                    <Fragment>
                                                        {this.state.messages.map(
                                                            (message, i) => {
                                                                return (
                                                                    <div
                                                                        date={
                                                                            message.updated_at
                                                                        }
                                                                        key={i}
                                                                        className="px-4 py-2 sm:px-6 mb-3 overflow-hidden w-full messageElement"
                                                                    >
                                                                        <dl className=" w-full text-left float-left">
                                                                            <Fragment>
                                                                                <div className="float-left messageAvatarBlock">
                                                                                    <span className=" inline-block messageAvatar relative">
                                                                                        <img
                                                                                            className="h-8 w-8  rounded-full"
                                                                                            src={
                                                                                                message
                                                                                                    .user
                                                                                                    .image
                                                                                            }
                                                                                            alt=""
                                                                                        />
                                                                                        {
                                                                                            message.user
                                                                                            .online ===
                                                                                        "online" ? (
                                                                                            <span className="absolute bottom-0 right-0 block h-2 w-2 rounded-full text-white shadow-solid bg-green-400"></span>
                                                                                        ) : (
                                                                                            <span className="absolute bottom-0 right-0 block h-2 w-2 rounded-full text-white shadow-solid bg-red-400"></span>
                                                                                        )}
                                                                                    </span>
                                                                                </div>

                                                                                <div className="ml-3 float-left messageBlock">
                                                                                    <div className="overflow-hidden ">
                                                                                        <p className="text-sm mb-2 float-left  leading-5 font-black text-gray-700 group-hover:text-gray-900">
                                                                                            {
                                                                                                message
                                                                                                    .user
                                                                                                    .first_name
                                                                                            }{" "}
                                                                                            {
                                                                                                message
                                                                                                    .user
                                                                                                    .last_name
                                                                                            }
                                                                                        </p>
                                                                                        <p className="text-sm mb-2 float-right leading-5 text-gray-500">
                                                                                            <div
                                                                                                date={
                                                                                                    message.created_at
                                                                                                }
                                                                                                formatter={
                                                                                                    formatter
                                                                                                }
                                                                                            >{ message.created_at}</div>
                                                                                        </p>
                                                                                    </div>

                                                                                    <div
                                                                                        className="w-11/12"
                                                                                        dangerouslySetInnerHTML={{
                                                                                            __html:
                                                                                                message.message,
                                                                                        }}
                                                                                    ></div>

                                                                                    {message
                                                                                        .files
                                                                                        .length >=
                                                                                    1 ? (
                                                                                        <div className="sm:col-span-2 text-left attachments">
                                                                                            <dt className="text-sm  mt-2 leading-5 font-medium text-gray-500">
                                                                                                Attachments
                                                                                            </dt>
                                                                                            <dd className="mt-1 text-sm leading-5 text-gray-900">
                                                                                                <ul className="border border-gray-200 rounded-md">
                                                                                                    {message.files.map(
                                                                                                        (
                                                                                                            file,
                                                                                                            f
                                                                                                        ) => {
                                                                                                            return (
                                                                                                                <li
                                                                                                                    key={
                                                                                                                        f
                                                                                                                    }
                                                                                                                    className="pl-3 pr-4 py-3 flex items-center justify-between text-sm leading-5"
                                                                                                                >
                                                                                                                    <div className="w-0 flex-1 flex items-center">
                                                                                                                        <svg
                                                                                                                            className="flex-shrink-0 h-5 w-5 text-gray-400"
                                                                                                                            fill="currentColor"
                                                                                                                            viewBox="0 0 20 20"
                                                                                                                        >
                                                                                                                            <path
                                                                                                                                fillRule="evenodd"
                                                                                                                                d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z"
                                                                                                                            />
                                                                                                                        </svg>
                                                                                                                        <span className="ml-2 flex-1 w-0 truncate">
                                                                                                                            {
                                                                                                                                file.name
                                                                                                                            }
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                    <div className="ml-4 flex-shrink-0">
                                                                                                                        <a
                                                                                                                             onClick={() =>
                                                                                                                                this.downloadFile(file.url)
                                                                                                                            }

                                                                                                                            className="font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out"
                                                                                                                        >
                                                                                                                            Download
                                                                                                                        </a>
                                                                                                                    </div>
                                                                                                                </li>
                                                                                                            );
                                                                                                        }
                                                                                                    )}
                                                                                                </ul>
                                                                                            </dd>
                                                                                        </div>
                                                                                    ) : null}
                                                                                </div>
                                                                            </Fragment>
                                                                        </dl>
                                                                    </div>
                                                                );
                                                            }
                                                        )}
                                                        <div
                                                            ref={
                                                                this
                                                                    .messagesEndRef
                                                            }
                                                        />
                                                    </Fragment>
                                                </Scrollbars>
                                            </div>
                                            <div className="messageUpload">
                                                <DropzoneComponent
                                                    config={{
                                                        postUrl:
                                                            this.context.state
                                                                .uploadUrl +
                                                            "/api/upload/file",
                                                    }}
                                                    djsConfig={this.djsConfig}
                                                />
                                                <svg
                                                    className="messageUploadFile flex-shrink-0 h-4 w-5 text-gray-600"
                                                    fill="currentColor"
                                                    viewBox="0 0 20 20"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z"
                                                    ></path>
                                                </svg>
                                            </div>
                                            <ReactQuill
                                                readOnly = {this.context.state.user.type =="writer" && this.context.state.user.plan_id === 1 ? true : false}
                                                onChange={this.handleChange}
                                                value={this.state.editorHtml}
                                                theme="snow"
                                                modules={this.modules}
                                                formats={this.formats}
                                            />
                                            <div className="attachFiles">
                                                {this.state.files.map(
                                                    (file, i) => {
                                                        return (
                                                            <span class="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium leading-5 bg-indigo-100 text-indigo-800">
                                                                <img
                                                                    onClick={() =>
                                                                        this.removeFile(
                                                                            i
                                                                        )
                                                                    }
                                                                    class="-ml-0.5 mr-1.5 h-2 w-2 text-indigo-400"
                                                                    src="/images/close.svg"
                                                                />

                                                                {file.name}
                                                            </span>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </Fragment>
                ) : (
                    <Waiting></Waiting>
                )}
            </Fragment>
        );
    }
}
Messages.contextType = AppContext;
export default Messages;



// WEBPACK FOOTER //
// ./src/components/messages/Messages.js